import serviceAxios from './serviceAxios';

const fetch = {
    get: function (url, data, config = {}) {
        return serviceAxios({
            url: url,
            method: 'get',
            params: data,
            ...config
        });
    },
    post: function (url, data, config = {}) {
        return serviceAxios({
            url: url,
            method: 'post',
            data,
            ...config
        });
    },
    put: function (url, data, config = {}) {
        return serviceAxios({
            url: url,
            method: 'put',
            data,
            ...config
        });
    },
    delete: function (url, data, config = {}) {
        return serviceAxios({
            url: url,
            method: 'delete',
            data,
            ...config
        });
    },
    request: serviceAxios
};

export default fetch;
